(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["flywheel"] = factory();
	else
		root["flywheel"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// Babel6 does not hack the default behaviour of ES Modules anymore, so we should export
	
	var flywheel = __webpack_require__(1).default;
	
	module.exports = flywheel;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ax = _axios2.default.create({
	  baseURL: 'https://mobile.flywheel.com'
	});
	
	// We pass the data to the promises objects, not the status, headers and config
	ax.interceptors.response.use(function (response) {
	  return response.data;
	}, function (error) {
	  return Promise.reject(error.data);
	});
	
	var _verifyRequiredParams = function _verifyRequiredParams(params) {
	  var missingParams = [];
	  Object.keys(params).forEach(function (key) {
	    if (!params[key]) {
	      missingParams.push(key);
	    }
	  });
	  if (missingParams.length > 0) {
	    throw new Error('Missing parameters: ' + missingParams);
	  }
	};
	
	var _authorizedGetRequest = function _authorizedGetRequest(requiredParams, path, authToken) {
	  _verifyRequiredParams(requiredParams);
	  return ax.get(path, {
	    params: {
	      auth_token: authToken
	    }
	  });
	};
	
	/**
	The flywheeljs library main exported object
	@namespace {object} flywheel
	*/
	var flywheel = {
	
	  /**
	   * The type of the object returned with a successfully resolved signup promise.
	   * @name SignupPromise
	   * @typedef {object} SignupPromise
	   * @property {string} auth_token - The token that can be used to authenticate future requests
	   * @property {object} passenger - An object including the user information. Some relevant fields are: `id`, `first_name`, `last_name`, and `email`.
	   */
	  /**
	   * Sign up a new user for the Flywheel service
	   *
	   * @example
	   * flywheel.signup({
	   *   firstName: 'John',
	   *   email: 'john@doe.com',
	   *   password: 'johndoe123',
	   *   telephone: '123123123',
	   *   latitude: 37.615223,
	   *   longitude: -122.389977
	   * })
	   * .then(response => {
	   *   console.log(response.data.passenger);
	   * })
	   * .catch(response => {
	   *   console.log(response.data.error);
	   * });
	   * @param {object} options - Options object parameter
	   * @param {string} options.firstName - Flywheel user first name
	   * @param {string} options.email - Flywheel user email
	   * @param {string} options.password - Flywheel user password
	   * @param {string} options.telephone - Flywheel user phone number
	   * @param {number} [options.latitude=0] - Default latitude (in degrees). This value can be overriden when ordering a cab
	   * @param {number} [options.longitude=0] - Default longitude (in degrees). This value can be overriden when ordering a cab
	   * @return {Promise} A promise that returns {@link SignupPromise} if resolved and an object containing the error if rejected.
	  */
	
	  signup: function signup() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var firstName = _ref.firstName;
	    var email = _ref.email;
	    var password = _ref.password;
	    var telephone = _ref.telephone;
	    var _ref$latitude = _ref.latitude;
	    var latitude = _ref$latitude === undefined ? 0 : _ref$latitude;
	    var _ref$longitude = _ref.longitude;
	    var longitude = _ref$longitude === undefined ? 0 : _ref$longitude;
	
	    _verifyRequiredParams({ firstName: firstName, email: email, password: password, telephone: telephone });
	    return ax.post('/passengers', {
	      first_name: firstName,
	      email: email,
	      password: password,
	      telephone: telephone,
	      latitude: parseFloat(latitude),
	      longitude: parseFloat(longitude),
	      adjust_xid_type: 'idfa',
	      adjust_xid: '12345678-1234-1234-1234-123456789012',
	      persistent_device_id: '12345678-1234-1234-1234-123456789012'
	    });
	  },
	
	
	  /**
	   * The type of the object returned with a successfully resolved search promise.
	   * @name SearchPromise
	   * @typedef {object} SearchPromise
	   * @property {array} drivers - An array containing the drivers available at that location. Some relevant fields are: `id`, `vehicle`, `latitude` and `longitude`.
	   */
	  /**
	   * Search for cabs around a given position
	   *
	   * @param {object} options - Options object parameter
	   * @param {string} [options.by='location'] - The field to search by
	   * @param {string} [options.filter='hailable'] - A filter to be applied to the search request
	   * @param {number} [options.latitude=0] - Default latitude (in degrees) used when ordering cabs
	   * @param {number} [options.longitude=0] - Default longitude (in degrees) used when ordering cabs
	   * @param {number} [options.authToken='(null)'] - User authentication token (if she's logged)
	   * @return {Promise} A promise that returns {@link SearchPromise} if resolved and an object containing the error if rejected.
	  */
	  search: function search() {
	    var _ref2 = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var _ref2$by = _ref2.by;
	    var by = _ref2$by === undefined ? 'location' : _ref2$by;
	    var _ref2$filter = _ref2.filter;
	    var filter = _ref2$filter === undefined ? 'hailable' : _ref2$filter;
	    var _ref2$latitude = _ref2.latitude;
	    var latitude = _ref2$latitude === undefined ? 0 : _ref2$latitude;
	    var _ref2$longitude = _ref2.longitude;
	    var longitude = _ref2$longitude === undefined ? 0 : _ref2$longitude;
	    var _ref2$authToken = _ref2.authToken;
	    var authToken = _ref2$authToken === undefined ? '(null)' : _ref2$authToken;
	
	    return ax.get('/search', {
	      params: {
	        by: by,
	        filter: filter,
	        latitude: parseFloat(latitude),
	        longitude: parseFloat(longitude),
	        auth_token: authToken
	      }
	    });
	  },
	
	
	  /**
	   * The type of the object returned with a successfully resolved login promise.
	   * @name LoginPromise
	   * @typedef {object} LoginPromise
	   * @property {string} auth_token - The token that can be used to authenticate future requests
	   * @property {object} passenger - An object including the user information. Some relevant fields are: `id`, `first_name`, `last_name`, and `email`.
	   * @property {object} scheduled_rides - An array containing the user scheduled rides
	   */
	  /**
	   * Login a user
	   *
	   * @param {object} options - Options object parameter
	   * @param {string} options.email - The user email
	   * @param {string} options.password - The user password
	   * @return {Promise} A promise that returns {@link LoginPromise} if resolved and an object containing the error if rejected.
	  */
	  login: function login(_ref3) {
	    var email = _ref3.email;
	    var password = _ref3.password;
	
	    _verifyRequiredParams({ email: email, password: password });
	    return ax.post('/login', {
	      email: email,
	      password: password
	    });
	  },
	
	
	  /**
	   * The type of the object returned with a successfully resolved application context promise. I added a question mark on those properties that are not clear to me.
	   * @name ApplicationContextPromise
	   * @typedef {object} ApplicationContextPromise
	   * @property {array} service_availabilities - An array of the services available at the given location. The service 'id' parameter is required for other requests (createRide, for example)
	   * @property {object} on_board_cancellation_window - The amount of time (in secs) allowed to cancel a ride without being charged
	   * @property {object} application_details - Some applications details, like the url on the app store
	   * @property {number} flywheel_service_fee - The fee charged by flywheel (in cents)
	   * @property {number} hailing_distance - Max hailing distance in meters (?)
	   * @property {number} maximum_hail_time - Max hail time in secs (before a request fails?)
	   * @property {number} straight_line_approximation_speed - ?
	   * @property {array} points_of_interest - ?
	   * @property {array} alerts - ?
	   * @property {number} on_board_cancellation_window - The amount of time (in secs) where a cancellation is not charged (?)
	   * @property {number} gps_warning_distance - ?
	   * @property {string} preferred_eta_provider - ?
	   * @property {number} booked_ride_countdown_window - ?
	   * @property {object} invite_friends - Referral rewards (in cents)
	   * @property {string} time_zone_identifier - Time zone
	   * @property {number} utc_offset - Offset (in secs) from UTC time
	   * @property {string} share_eta_msg - Some string used in the app UI
	   * @property {bool} enable_asking_point - ?
	  */
	  /**
	   * Get some application context data given a specific location.
	   *
	   * @param {object} options - Options object parameter
	   * @param {string} options.authToken - An authentication token
	   * @param {number} options.latitude - A given latitude (in degrees) used when ordering cabs
	   * @param {number} options.longitude - A given longitude (in degrees) used when ordering cabs
	   * @return {Promise} A promise that returns {@link ApplicationContextPromise} if resolved and an object containing the error if rejected.
	  */
	  applicationContext: function applicationContext(_ref4) {
	    var authToken = _ref4.authToken;
	    var _ref4$latitude = _ref4.latitude;
	    var latitude = _ref4$latitude === undefined ? 0 : _ref4$latitude;
	    var _ref4$longitude = _ref4.longitude;
	    var longitude = _ref4$longitude === undefined ? 0 : _ref4$longitude;
	
	    return ax.get('/application_context', {
	      params: {
	        application: 'Flywheel',
	        platform: 'ios',
	        version: '5.6.7',
	        platform_version: '9.2.1',
	        latitude: parseFloat(latitude),
	        longitude: parseFloat(longitude),
	        auth_token: authToken
	      }
	    });
	  },
	
	
	  /**
	   * The type of the object returned with a successfully resolved user info promise. I added a question mark on those properties that are not clear to me.
	   * @name UserInfoPromise
	   * @typedef {object} UserInfoPromise
	   * @property {string} id - The user (passenger) id
	   * @property {string} first_name - The user first name
	   * @property {string} last_name - The user last name
	   * @property {string} email - The user email
	   * @property {bool} has_dummy_email - True if the user has a dummy email (whatever that might mean)
	   * @property {string} telephone - The user telephone
	   * @property {string} canonical_telephone - ?
	   * @property {array} addresses - The user addresses
	   * @property {array} mobile_devices - The user mobile devices
	   * @property {array} dispatch_service_accounts - ?
	   * @property {number} default_tip_percent - Default tip percentage
	   * @property {number} credit_balance - ?
	   * @property {number} credits_since_last_session - ?
	   * @property {array} payment_instruments - The payment instruments linked to this user. The payment object contains a property `token` that is required for creating rides
	   * @property {number} payment_instruments_count - Number of payment instruments
	   * @property {string} latest_ride_id - Latest ride id
	   * @property {string} referral_code - Referral code for this user
	   * @property {string} latest_ride_id - Latest ride id
	   * @property {array} nonfatal_errors - ?
	   * @property {array} disabled_features - ?
	   * @property {string} oauth_id - ?
	   * @property {string} oauth_provider - I guess Google, FB, etc.
	   * @property {bool} sms_verification_required - ?
	   * @property {bool} is_agent_also - ?
	   * @property {string} added_by - ?
	   * @property {array} special_characteristics - ?
	   * @property {bool} ivr_blocked - ?
	   * @property {bool} newly_added - ?
	   * @property {object} suspended_upto - ?
	  */
	  /**
	   * Get user info
	   *
	   * @param {object} options - Options object parameter
	   * @param {string} options.userId - The user id. It can be obtained from the 'passenger' object after logging in
	   * @param {string} options.authToken - The authentication token
	   * @return {Promise} A promise that returns {@link UserInfoPromise} if resolved and an object containing the error if rejected.
	  */
	  userInfo: function userInfo(_ref5) {
	    var userId = _ref5.userId;
	    var authToken = _ref5.authToken;
	
	    return _authorizedGetRequest({ userId: userId, authToken: authToken }, '/passengers/' + userId, authToken);
	  },
	
	
	  /**
	   * The type of the object returned with a successfully resolved search promise.
	   * @name ETAPromise
	   * @typedef {object} ETAPromise
	   * @property {string} status - "OK" if the location can be reached
	   * @property {array} response - An array that contains at least one object with the estimated durations. It has the following properties: 'duration' (in secs), 'duration_in_traffic' (in secs) and 'distance'
	   */
	  /**
	   * Get estimated time of arrival
	   *
	   * @param {object} options - Options object parameter
	   * @param {string} options.origin - The user id. It can be obtained from the 'passenger' object after logging in)
	   * @param {string} options.authToken - The authentication token
	   * @return {Promise} A promise that returns {@link ETAPromise} if resolved and an object containing the error if rejected.
	  */
	  eta: function eta(_ref6) {
	    var origin = _ref6.origin;
	    var destination = _ref6.destination;
	    var authToken = _ref6.authToken;
	
	    _verifyRequiredParams({ origin: origin, destination: destination, authToken: authToken });
	    return ax.get('/eta', {
	      params: {
	        origins: origin,
	        destinations: destination,
	        auth_token: authToken
	      }
	    });
	  },
	
	
	  /**
	   * The type of the object returned with a successfully resolved ride promise. It includes a lot of properties, only the most interesting ones are documented here.
	   * @name RidePromise
	   * @typedef {object} RidePromise
	   * @property {string} id - The ride id
	   * @property {string} notes - The notes attached to the ride, created by the user
	   * @property {string} status - `hailing` if the ride is still to be assigned, `hail_accepted` if a cab driver accepted the ride, `canceled` if it's been canceled
	   * @property {string} failure_reason - The reason why the ride failed, if any
	   * @property {string} client_created_at - Formatted creation date
	   * @property {number} created_at - Creation timestamp
	   * @property {number} updated_at - The reason why the ride failed
	   * @property {object} passenger - An object with the same structure than {@link UserInfoPromise}
	   * @property {object} pick_up_location - Pick up location
	   * @property {object} drop_off_location - Drop off location (can be empty)
	   * @property {object} hail - This object contains all details about the `hail`, including the driver information
	   * @property {object} payment_instrument - The payment instrument used to pay for this ride
	   */
	  /**
	   * Create a new request for a ride
	   *
	   * @param {object} options - Options object parameter
	   * @param {number} options.pickUpLat - Pickup latitude (in degrees)
	   * @param {number} options.pickUpLon - Pickup latitude (in degrees)
	   * @param {string} options.address - The pickup address, for example: "22 Estate Ct". Use some geocoding service like google maps to obtain it: http://maps.googleapis.com/maps/api/geocode/json?address=<user_typed_address>
	   * @param {string} options.state - The state short name, for example: "CA". Use some geocoding service like google maps to obtain it: http://maps.googleapis.com/maps/api/geocode/json?address=<user_typed_address>
	   * @param {string} options.country - The country name, for example: "United States". Use some geocoding service like google maps to obtain it: http://maps.googleapis.com/maps/api/geocode/json?address=<user_typed_address>
	   * @param {string} options.city - The city name, for example: "South San Francisco". Use some geocoding service like google maps to obtain it: http://maps.googleapis.com/maps/api/geocode/json?address=<user_typed_address>
	   * @param {object} options.passenger - The passenger object. Only 'name' (string) and 'telephone' (string) are required
	   * @param {string} options.serviceAvailabilitiesId - The service id. It can be obtained using `applicationContext()`
	   * @param {number} options.tip - The ride tip (in cents)
	   * @param {string} options.authToken - The authentication token
	   * @param {string} options.notes - Any notes to be sent to the cab driver
	   * @return {Promise} A promise that returns {@link RidePromise} if resolved and an object containing the error if rejected.
	  */
	  createRide: function createRide(_ref7) {
	    var pickUpLat = _ref7.pickUpLat;
	    var pickUpLon = _ref7.pickUpLon;
	    var address = _ref7.address;
	    var state = _ref7.state;
	    var country = _ref7.country;
	    var city = _ref7.city;
	    var passenger = _ref7.passenger;
	    var paymentToken = _ref7.paymentToken;
	    var serviceAvailabilitiesId = _ref7.serviceAvailabilitiesId;
	    var _ref7$tip = _ref7.tip;
	    var tip = _ref7$tip === undefined ? 500 : _ref7$tip;
	    var _ref7$authToken = _ref7.authToken;
	    var authToken = _ref7$authToken === undefined ? '(null)' : _ref7$authToken;
	    var _ref7$notes = _ref7.notes;
	    var notes = _ref7$notes === undefined ? '' : _ref7$notes;
	
	    _verifyRequiredParams({ pickUpLat: pickUpLat, pickUpLon: pickUpLon, address: address, state: state, country: country, city: city, passenger: passenger, paymentToken: paymentToken, serviceAvailabilitiesId: serviceAvailabilitiesId });
	    var clientCreatedAt = new Date().toISOString().replace(/T/g, '-').slice(0, -5);
	    return ax.post('/rides', {
	      source: 'Mobile:iOS:5.6.7:Flywheel',
	      pick_up_location: {
	        latitude: parseFloat(pickUpLat),
	        longitude: parseFloat(pickUpLon),
	        address_1: address,
	        state: state,
	        country: country,
	        city: city
	      },
	      guaranteed_tip_details: {
	        type: 'cents',
	        amount: tip
	      },
	      notes: notes,
	      requirements: { service_availability_ids: [serviceAvailabilitiesId] },
	      passenger: passenger,
	      auth_token: authToken,
	      payment_instrument: {
	        token: paymentToken
	      },
	      client_created_at: clientCreatedAt
	    });
	  },
	
	
	  /**
	   * Get the status of a specific ride
	   *
	   * @param {object} options - Options object parameter
	   * @param {number} options.rideId - The ride id
	   * @param {number} options.authToken - The authentication token
	   * @return {Promise} A promise that returns {@link RidePromise} if resolved and an object containing the error if rejected.
	  */
	  getRideStatus: function getRideStatus(_ref8) {
	    var rideId = _ref8.rideId;
	    var authToken = _ref8.authToken;
	
	    return _authorizedGetRequest({ rideId: rideId, authToken: authToken }, '/rides/' + rideId, authToken);
	  },
	
	
	  /**
	   * Cancel a specific ride
	   *
	   * @param {object} options - Options object parameter
	   * @param {number} options.rideId - The ride id
	   * @param {number} options.authToken - The authentication token
	   * @return {Promise} A promise that returns {@link RidePromise} if resolved and an object containing the error if rejected.
	  */
	  cancelRide: function cancelRide(_ref9) {
	    var rideId = _ref9.rideId;
	    var authToken = _ref9.authToken;
	
	    _verifyRequiredParams({ rideId: rideId, authToken: authToken });
	    var ridesUrl = '/rides/' + rideId;
	    return ax.post(ridesUrl + '/cancellation_contract', {
	      auth_token: authToken
	    }).then(function (response) {
	      return ax.put(ridesUrl, {
	        status: 'canceled',
	        auth_token: authToken
	      });
	    });
	  }
	};
	
	exports.default = flywheel;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3);

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(4);
	var utils = __webpack_require__(5);
	var dispatchRequest = __webpack_require__(6);
	var InterceptorManager = __webpack_require__(15);
	var isAbsoluteURL = __webpack_require__(16);
	var combineURLs = __webpack_require__(17);
	var bind = __webpack_require__(18);
	var transformData = __webpack_require__(11);
	
	function Axios(defaultConfig) {
	  this.defaults = utils.merge({}, defaultConfig);
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Don't allow overriding defaults.withCredentials
	  config.withCredentials = config.withCredentials || this.defaults.withCredentials;
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	var defaultInstance = new Axios(defaults);
	var axios = module.exports = bind(Axios.prototype.request, defaultInstance);
	
	axios.create = function create(defaultConfig) {
	  return new Axios(defaultConfig);
	};
	
	// Expose defaults
	axios.defaults = defaultInstance.defaults;
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(19);
	
	// Expose interceptors
	axios.interceptors = defaultInstance.interceptors;
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	module.exports = {
	  transformRequest: [function transformResponseJSON(data, headers) {
	    if (utils.isFormData(data)) {
	      return data;
	    }
	    if (utils.isArrayBuffer(data)) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isObject(data) && !utils.isFile(data) && !utils.isBlob(data)) {
	      // Set application/json if no Content-Type has been specified
	      if (!utils.isUndefined(headers)) {
	        utils.forEach(headers, function processContentTypeHeader(val, key) {
	          if (key.toLowerCase() === 'content-type') {
	            headers['Content-Type'] = val;
	          }
	        });
	
	        if (utils.isUndefined(headers['Content-Type'])) {
	          headers['Content-Type'] = 'application/json;charset=utf-8';
	        }
	      }
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponseJSON(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    },
	    patch: utils.merge(DEFAULT_CONTENT_TYPE),
	    post: utils.merge(DEFAULT_CONTENT_TYPE),
	    put: utils.merge(DEFAULT_CONTENT_TYPE)
	  },
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN'
	};


/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return toString.call(val) === '[object FormData]';
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  trim: trim
	};


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/**
	 * Dispatch a request to the server using whichever adapter
	 * is supported by the current environment.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  return new Promise(function executor(resolve, reject) {
	    try {
	      var adapter;
	
	      if (typeof config.adapter === 'function') {
	        // For custom adapter support
	        adapter = config.adapter;
	      } else if (typeof XMLHttpRequest !== 'undefined') {
	        // For browsers use XHR adapter
	        adapter = __webpack_require__(8);
	      } else if (typeof process !== 'undefined') {
	        // For node use HTTP adapter
	        adapter = __webpack_require__(8);
	      }
	
	      if (typeof adapter === 'function') {
	        adapter(resolve, reject, config);
	      }
	    } catch (e) {
	      reject(e);
	    }
	  });
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ },
/* 7 */
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var buildURL = __webpack_require__(9);
	var parseHeaders = __webpack_require__(10);
	var transformData = __webpack_require__(11);
	var isURLSameOrigin = __webpack_require__(12);
	var btoa = window.btoa || __webpack_require__(13);
	
	module.exports = function xhrAdapter(resolve, reject, config) {
	  var requestData = config.data;
	  var requestHeaders = config.headers;
	
	  if (utils.isFormData(requestData)) {
	    delete requestHeaders['Content-Type']; // Let the browser set it
	  }
	
	  var request = new XMLHttpRequest();
	
	  // For IE 8/9 CORS support
	  // Only supports POST and GET calls and doesn't returns the response headers.
	  if (window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
	    request = new window.XDomainRequest();
	  }
	
	  // HTTP basic authentication
	  if (config.auth) {
	    var username = config.auth.username || '';
	    var password = config.auth.password || '';
	    requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	  }
	
	  request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	  // Set the request timeout in MS
	  request.timeout = config.timeout;
	
	  // Listen for ready state
	  request.onload = function handleLoad() {
	    if (!request) {
	      return;
	    }
	    // Prepare the response
	    var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	    var responseData = ['text', ''].indexOf(config.responseType || '') !== -1 ? request.responseText : request.response;
	    var response = {
	      data: transformData(
	        responseData,
	        responseHeaders,
	        config.transformResponse
	      ),
	      // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	      status: request.status === 1223 ? 204 : request.status,
	      statusText: request.status === 1223 ? 'No Content' : request.statusText,
	      headers: responseHeaders,
	      config: config
	    };
	
	    // Resolve or reject the Promise based on the status
	    ((response.status >= 200 && response.status < 300) ||
	     (!('status' in request) && response.responseText) ?
	      resolve :
	      reject)(response);
	
	    // Clean up request
	    request = null;
	  };
	
	  // Handle low level network errors
	  request.onerror = function handleError() {
	    // Real errors are hidden from us by the browser
	    // onerror should only fire if it's a network error
	    reject(new Error('Network Error'));
	
	    // Clean up request
	    request = null;
	  };
	
	  // Add xsrf header
	  // This is only done if running in a standard browser environment.
	  // Specifically not if we're in a web worker, or react-native.
	  if (utils.isStandardBrowserEnv()) {
	    var cookies = __webpack_require__(14);
	
	    // Add xsrf header
	    var xsrfValue = config.withCredentials || isURLSameOrigin(config.url) ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	    if (xsrfValue) {
	      requestHeaders[config.xsrfHeaderName] = xsrfValue;
	    }
	  }
	
	  // Add headers to the request
	  if ('setRequestHeader' in request) {
	    utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	      if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	        // Remove Content-Type if data is undefined
	        delete requestHeaders[key];
	      } else {
	        // Otherwise add header to the request
	        request.setRequestHeader(key, val);
	      }
	    });
	  }
	
	  // Add withCredentials to request if needed
	  if (config.withCredentials) {
	    request.withCredentials = true;
	  }
	
	  // Add responseType to request if needed
	  if (config.responseType) {
	    try {
	      request.responseType = config.responseType;
	    } catch (e) {
	      if (request.responseType !== 'json') {
	        throw e;
	      }
	    }
	  }
	
	  if (utils.isArrayBuffer(requestData)) {
	    requestData = new DataView(requestData);
	  }
	
	  // Send the request
	  request.send(requestData);
	};


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};
	


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function InvalidCharacterError(message) {
	  this.message = message;
	}
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.code = 5;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new InvalidCharacterError('INVALID_CHARACTER_ERR: DOM Exception 5');
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 19 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }
/******/ ])
});
;
//# sourceMappingURL=flywheel-browser.js.map